import { render } from "./EditProject.vue?vue&type=template&id=5cac1a74&scoped=true"
import script from "./EditProject.vue?vue&type=script&lang=js"
export * from "./EditProject.vue?vue&type=script&lang=js"

import "./EditProject.vue?vue&type=style&index=0&id=5cac1a74&lang=less"
import "./EditProject.vue?vue&type=style&index=1&id=5cac1a74&lang=less&scoped=true"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cac1a74"]])

export default __exports__